import React, { useState } from 'react'
import Mainmenu from "./MainMenu";
import you from '../../assets/images/boy.png'

import bot from '../../assets/images/happy.png'; 

const ContactUs = () => {

    const [showMenu, setShowMenu] = useState(true);

    const [showFrame1, setShowFrame1] = useState(false);

    const [time, setTime] = useState(new Date());

  return (
    <div>
        <div className="frame1 animated-frame">
        You can access our contact information here
        </div>
        <div className="frame1 animated-frame">
        If you have additional questions, select an option below.
        </div>

        {showMenu &&(
            <div className='menu-btns animated-frame'>
                <button className='menu-btn'>Email Support</button>
                <button className='menu-btn'>Phone Support</button>
                <button className='menu-btn'>Live Chat</button>
                <button className='menu-btn' onClick={() => {
                            setShowMenu(false);
                            setShowFrame1(true);
                            }}>Restart the chat</button>
            </div>
        )}

        {showFrame1 && (
            <>
                <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
                </div>
                <div className="you-message">
                <div className="frame2">Restart the chat</div>
                </div>

                <div className='chatbot'>
                <img src={bot} alt="bot" className="bot" />
                <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                </div>
                    <Mainmenu />
                </>
        )}


    </div>
  )
}

export default ContactUs